module.exports = __webpack_public_path__ + "static/media/Icon-awesome-facebook-square.d6ea92a9.svg";